import { RESET_DIALOG, useLightBoxLoginContext } from 'components/light-box-login/use-light-box-login';
import autopass from 'images/landing/app_autopass.png';
import cathay from 'images/landing/app_cathay.png';
import mytoyota from 'images/landing/app_mytoyota.png';
import cpcpay from 'images/landing/app_cpcpay.png';
import waffle from 'images/landing/app_waffle.png';
import iknow99 from 'images/landing/app_iknow99.png';
import linebank from 'images/landing/app_linebank.png';
import npcpay from 'images/landing/app_npc.png';
import lexusPlus from 'images/landing/app_lexusplus.png';
import styles from 'components/light-box-login/index.module.scss';
import { Button } from 'mochi-react-component';
import React, { useEffect } from 'react';
import classnames from 'classnames/bind';
import {
  autopassDownloadLink,
  mochiClientWebUrl,
  cpcpayDownloadLink,
  waffleDownloadLink,
  iknow99DownloadLink,
  linebankDownloadLink,
  myToyotaDownloadLink,
} from 'config';
import { useHistory } from 'react-router-dom';
import { deviceOSType } from 'utils/device-util';
import { npcpayDownloadLink } from 'config';
import { lexusPlusDownloadLink } from 'config';

const DownloadStep = ({ onDismiss }) => {
  const cx = classnames.bind(styles);
  const { state, dispatch } = useLightBoxLoginContext();
  const history = useHistory();

  const onGoBack = () => {
    dispatch({
      type: RESET_DIALOG,
    });
    onDismiss();
    history.push({ pathname: '/', hash: 'Download' });
  };

  const downloadData = [
    {
      icon: autopass,
      link: deviceOSType(autopassDownloadLink.ios, autopassDownloadLink.android, autopassDownloadLink.desktop),
    },
    {
      icon: linebank,
      link: deviceOSType(linebankDownloadLink.ios, linebankDownloadLink.android, linebankDownloadLink.desktop),
    },
    {
      icon: cpcpay,
      link: deviceOSType(cpcpayDownloadLink.ios, cpcpayDownloadLink.android, cpcpayDownloadLink.desktop),
    },
    {
      icon: npcpay,
      link: deviceOSType(npcpayDownloadLink.ios, npcpayDownloadLink.android, npcpayDownloadLink.desktop),
    },
    {
      icon: mytoyota,
      link: deviceOSType(myToyotaDownloadLink.ios, myToyotaDownloadLink.android, myToyotaDownloadLink.desktop),
    },
    {
      icon: lexusPlus,
      link: deviceOSType(lexusPlusDownloadLink.ios, lexusPlusDownloadLink.android, lexusPlusDownloadLink.desktop),
    },
    {
      icon: iknow99,
      link: deviceOSType(iknow99DownloadLink.ios, iknow99DownloadLink.android, iknow99DownloadLink.desktop),
    },
    {
      icon: waffle,
      link: deviceOSType(waffleDownloadLink.ios, waffleDownloadLink.android, waffleDownloadLink.desktop),
    },
    {
      id: 'cathayMr',
      icon: cathay,
      link: mochiClientWebUrl(),
    },
  ];

  const stepDownloadClass = cx({
    step: true,
    'step-download': true,
    in: state.downloadPageIn,
  });

  useEffect(() => {
    const preventTab = e => {
      if (e.which === 9 && state.downloadPageIn) {
        e.preventDefault();
      }
    };
    window.addEventListener('keydown', preventTab);
    return () => {
      window.removeEventListener('keydown', preventTab);
    };
  }, [state.downloadPageIn]);

  return (
    <div className={stepDownloadClass}>
      <div className={styles.title}>{state.isMember ? '立即使用' : '尚未完成註冊'}</div>
      <div className={styles.desc}>
        {state.isMember
          ? '以下平台皆可使用麻吉付，立即成為會員，開始使用享優惠！'
          : '您尚未完成註冊，請至以下支援麻吉付通路完成會員註冊。'}
      </div>
      <div className={styles.content}>
        <div className={styles.marquee} style={{ width: 140 * downloadData.length }}>
          {downloadData.concat(downloadData).map((data, i) => {
            return (
              <a href={data.link} target="_blank" className={styles.block} key={i} rel="noreferrer">
                <img src={data.icon} alt="dist" />
              </a>
            );
          })}
        </div>
      </div>
      <div className={styles.back}>
        <Button type="outline" onClick={onGoBack}>
          返回並前往下載
        </Button>
      </div>
    </div>
  );
};

export default DownloadStep;
